import { Form, Input, Typography } from 'antd';
import LocaleContext from 'locales';
import React, { useContext, useEffect, useState } from 'react';

function RequestInfo({ readOnly, detailData }) {
  const { locale } = useContext(LocaleContext);

  const Reason = ({ readOnly1, value, onChange }) => {
    const [text, setText] = useState('');

    useEffect(() => {
      setText(value);
    }, [value]);

    return readOnly1 ? (
      <Typography.Text style={{ whiteSpace: 'pre-line' }}> {text}</Typography.Text>
    ) : (
      <Input.TextArea
        value={text}
        onBlur={() => {
          onChange(text);
        }}
        onChange={(e) => setText(e.target.value)}
      />
    );
  };

  const applicantName = detailData ? detailData.applicantName : localStorage.getItem('username'); // 신청자 이름
  const applicant = detailData ? detailData.applicant : localStorage.getItem('userId'); // 신청자 ID

  return (
    <>
      <Form.Item label={locale.resource['txt.applicant']} required>
        <Input readOnly bordered={false} value={`${applicantName}(${applicant})`} />
      </Form.Item>
      <Form.Item
        label={locale.resource['txt.applicant']}
        name="applicant"
        initialValue={applicant}
        hidden
      >
        <Input />
      </Form.Item>

      {readOnly && (
        <Form.Item label={locale.resource['txt.requested-date']} name="applyDate" required>
          <Input readOnly={readOnly} bordered={false} />
        </Form.Item>
      )}
      <Form.Item
        label={locale.resource['txt.reason']}
        name="reason"
        rules={[{ required: true, message: locale.resource['txt.required-field'] }]}
      >
        <Reason readOnly1={readOnly} />
      </Form.Item>
    </>
  );
}

export default RequestInfo;
